import { Conatiner, TagWrapper, TitleWrapper, ScoreWrapper, Title } from './ThirdCardStyles';
import UpDownChip from '@/ui/caption/score3/Score3';
import Tag from '@/ui/tag/Tag';

interface ThirdCardProps {
  width?: string;
  height?: string;
  companyId?: string;
  companyName?: string;
  change?: number;
  score?: number;
  onClick?: () => void;
}

const ThirdCard = ({
  width = '208px',
  height = '160px',
  companyId,
  companyName,
  change,
  score,
  onClick,
}: ThirdCardProps) => {
  return (
    <Conatiner width={width} height={height} onClick={onClick}>
      <TitleWrapper>
        <TagWrapper>
          <Tag>{companyId}</Tag>
        </TagWrapper>
        <Title>
          <div className="text-text-500">{companyName}</div>
        </Title>
      </TitleWrapper>

      <ScoreWrapper>
        <div className="text-sm text-text-500">{score?.toFixed(2)}</div>
        <UpDownChip change={change} />
      </ScoreWrapper>
    </Conatiner>
  );
};

export default ThirdCard;
